/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-09 20:15:06
 */

export enum RecipeNormalFrequencyCategory {
  MRYT = '每日一帖',
  MRLT = '每日两帖',
  MRST = '每日三帖',
  MRSTS = '每日四帖',
  LRYT = '两日一帖',
  SRYT = '三日一帖',
}

export const RecipeNormalFrequencyCategories = [
  RecipeNormalFrequencyCategory.MRYT,
  RecipeNormalFrequencyCategory.MRLT,
  RecipeNormalFrequencyCategory.MRST,
  RecipeNormalFrequencyCategory.MRSTS,
  RecipeNormalFrequencyCategory.LRYT,
  RecipeNormalFrequencyCategory.SRYT,
]

export function RecipeNormalFrequencyName(
  recipeNormalFrequency: RecipeNormalFrequencyCategory
): string {
  switch (recipeNormalFrequency) {
    case '每日一帖':
      return '每日一帖'
    case '每日两帖':
      return '每日两帖'
    case '每日三帖':
      return '每日三帖'
    case '每日四帖':
      return '每日四帖'
    case '两日一帖':
      return '两日一帖'
    case '三日一帖':
      return '三日一帖'

  }
  return ''
}

export enum RecipeNormalUsemethodCategory {
  MTYC = '每帖一次',
  MTLC = '每帖两次',
  MTSC = '每帖三次',
  MTSCS = '每帖四次',
}

export const RecipeNormalUsemethodCategories = [
  RecipeNormalUsemethodCategory.MTYC,
  RecipeNormalUsemethodCategory.MTLC,
  RecipeNormalUsemethodCategory.MTSC,
  RecipeNormalUsemethodCategory.MTSCS,
]

export function RecipeNormalUsemethodName(
  recipeNormalUsemethod: RecipeNormalUsemethodCategory
): string {
  switch (recipeNormalUsemethod) {
    case '每帖一次':
      return '每帖一次'
    case '每帖两次':
      return '每帖两次'
    case '每帖三次':
      return '每帖三次'
    case '每帖四次':
      return '每帖四次'
  }
  return ''
}

export enum RecipeNormalDoseCategory {
  MC10 = '每次10ml',
  MC20 = '每次20ml',
  MC50 = '每次50ml',
  MC80 = '每次80ml',
  MC100 = '每次100ml',
  MC120 = '每次120ml',
  MC130 = '每次130ml',
  MC140 = '每次140ml',
  MC150 = '每次150ml',
  MC160 = '每次160ml',
  MC170 = '每次170ml',
  MC180 = '每次180ml',
  MC200 = '每次200ml',
  MC300 = '每次300ml',
}

export const RecipeNormalDoseCategories = [
  RecipeNormalDoseCategory.MC10,
  RecipeNormalDoseCategory.MC20,
  RecipeNormalDoseCategory.MC50,
  RecipeNormalDoseCategory.MC80,
  RecipeNormalDoseCategory.MC100,
  RecipeNormalDoseCategory.MC120,
  RecipeNormalDoseCategory.MC130,
  RecipeNormalDoseCategory.MC150,
  RecipeNormalDoseCategory.MC160,
  RecipeNormalDoseCategory.MC170,
  RecipeNormalDoseCategory.MC180,
  RecipeNormalDoseCategory.MC200,
  RecipeNormalDoseCategory.MC300,
]

export function RecipeNormalDoseTypeName(
  recipeNormalDose: RecipeNormalDoseCategory
): string {
  switch (recipeNormalDose) {
    case '每次10ml':
      return '每次10ml'
    case '每次20ml':
      return '每次20ml'
    case '每次50ml':
      return '每次50ml'
    case '每次80ml':
      return '每次80ml'
    case '每次100ml':
      return '每次100ml'
    case '每次120ml':
      return '每次120ml'
    case '每次130ml':
      return '每次130ml'
    case '每次140ml':
      return '每次140ml'
    case '每次150ml':
      return '每次150ml'
    case '每次160ml':
      return '每次160ml'
    case '每次170ml':
      return '每次170ml'
    case '每次180ml':
      return '每次180ml'
    case '每次200ml':
      return '每次200ml'
    case '每次300ml':
      return '每次300ml'
  }
  return ''
}
